import { createAction } from 'typesafe-actions';
import { UICrumbType } from './UICrumb';

const enum Types {
    SHOW_POPUP = 'showPopup',
    HIDE_POPUP = 'hidePopup',
    SHOW_PRIO_POPUP = 'showPrioPopup',
    HIDE_PRIO_POPUP = 'hidePrioPopup',
    OPEN_MENU = 'openMenu',
}

export interface PopupActionPayload {
    popupID?: string;
    params?: any;
    crumb?: UICrumbType;
}

export const UIActions = {
    showPopup: createAction(
        Types.SHOW_POPUP,
        resolve => (popupID: string, params?: any, crumb?: UICrumbType) =>
            resolve<PopupActionPayload>({ popupID, params, crumb })
    ),
    hidePopup: createAction(
        Types.HIDE_POPUP,
        resolve => (popupID: string, params?: any) =>
            resolve<PopupActionPayload>({ popupID, params })
    ),
    showPrioPopup: createAction(
        Types.SHOW_PRIO_POPUP,
        resolve => (popupID: string, params?: any) =>
            resolve<PopupActionPayload>({ popupID, params })
    ),
    hidePrioPopup: createAction(
        Types.HIDE_PRIO_POPUP,
        resolve => (popupID: string, params?: any) =>
            resolve<PopupActionPayload>({ popupID, params })
    ),
    openMenu: createAction(Types.OPEN_MENU, resolve => (crumb: UICrumbType) =>
        resolve<UICrumbType>(crumb)
    ),
};
